import { useMemo } from "react";
import useAppSelector from "./useAppSelector";

export default function useAuth() {
  const auth = useAppSelector(state => state.auth);

  return useMemo(() => auth, [auth]);
}
